import React from 'react';

import {
  ActionBar,
  ClearButton,
  ContentWrapper,
  FormWrapper,
  Label,
  LabelContent,
  SubmitButton,
} from './styles';
import { Divider } from '@mui/material';

function FilterForm({
  label,
  onSubmit,
  clearFilter,
  dontShowClearButton,
  invalid,
  children,
  ...props
}) {
  const submit = e => {
    e.preventDefault();
    onSubmit(e);
  };

  return (
    <FormWrapper component="form" onSubmit={submit} {...props}>
      <LabelContent>
        <Label component="span">{label}</Label>
      </LabelContent>
      <ContentWrapper>{children}</ContentWrapper>
      <Divider style={{ marginLeft: 0, zIndex: 9 }} />
      <ActionBar dontShowClearButton={dontShowClearButton}>
        {dontShowClearButton ? null : (
          <ClearButton disabled={invalid} onClick={clearFilter}>
            Limpar
          </ClearButton>
        )}
        <SubmitButton disabled={invalid} type="submit">
          Aplicar
        </SubmitButton>
      </ActionBar>
    </FormWrapper>
  );
}

export default FilterForm;
